import React from 'react'
import ReactDOM from 'react-dom'
import get from 'lodash/get'
import flatMap from 'lodash/flatMap'
import isEmpty from 'lodash/isEmpty'
import every from 'lodash/every'

import { Tooltip } from '../../components/Tooltip'

export const renderTableTooltip = (ctx) => {
  let tooltip = initializeTooltip()

  const tooltipModel = get(ctx, 'tooltip', null)

  const dataPoints = get(tooltipModel, 'dataPoints', [])
  const dataset = dataPoints.find((dataset) => dataset.dataset.showCashflowEvents)

  const cashflowEvents = get(dataset, 'raw.cashflowEvents', [])
  const cashflowEventsDrawStatus = get(dataset, 'raw.cashflowEventsDrawStatus', {})

  if (isEmpty(cashflowEvents) || every(cashflowEvents, { status: 'inactive' }) ||
      !tooltipModel || tooltipModel.opacity === 0) {
    return
  }

  ReactDOM.render(
    <Tooltip
      onClose={() => {
        tooltip.style.opacity = 0
        tooltip.style.pointerEvents = 'none'
      }}
      cashflowEventsDrawStatus={cashflowEventsDrawStatus}
      cashflowEvents={cashflowEvents}
    />,
    tooltip
  )

  setTooltiptOpacity(tooltip, tooltipModel, cashflowEvents)
}

const initializeTooltip = () => {
  let tooltip = document.getElementById('table-tooltip')
  return tooltip
}

const setTooltiptOpacity = (tooltip, cashflowEvents) => {
  if (isEmpty(cashflowEvents)) {
    tooltip.style.opacity = 0
    tooltip.style.pointerEvents = 'none'
  } else {
    tooltip.style.opacity = 1
    tooltip.classList.add('active')
    tooltip.style.pointerEvents = 'all'
  }
}
